"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isImageEssenceProperty = exports.imageEssencePropertyDefinition = void 0;
exports.imageEssencePropertyDefinition = {
    view: {
        label: 'Image essence',
        style: '',
    },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
    ],
    type: 'mime:image',
    multiple: false,
    name: 'image-essence',
};
const isImageEssenceProperty = (prop) => {
    return prop.name === exports.imageEssencePropertyDefinition.name;
};
exports.isImageEssenceProperty = isImageEssenceProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW1hZ2UtZXNzZW5jZS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2ltYWdlLWVzc2VuY2UucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSw4QkFBOEIsR0FBRztJQUM1QyxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsZUFBZTtRQUN0QixLQUFLLEVBQUUsRUFBRTtLQUNWO0lBQ0QsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsSUFBSTtTQUNmO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsWUFBWTtJQUNsQixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxlQUFlO0NBQ1UsQ0FBQTtBQUkxQixNQUFNLHNCQUFzQixHQUFHLENBQUMsSUFBa0IsRUFBZ0MsRUFBRTtJQUN6RixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssc0NBQThCLENBQUMsSUFBSSxDQUFBO0FBQzFELENBQUMsQ0FBQTtBQUZZLFFBQUEsc0JBQXNCLDBCQUVsQyJ9